module.exports = __webpack_public_path__ + "media/assets/images/solutions/team_balance/hero_image-c413bfbb984d42331289693492b1acd1.png";